import React from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import socialModel from './social_models';
import { popupCenter, trackSocial } from '../../../utils/share_util';
import { trainParselyProfile } from '../../../client/utils/third_party_trackers/parsely';

function handleClick(event, url, popup, socialShare) {
  if (socialShare.action !== 'email') {
    event.preventDefault();
  }

  if (popup) {
    popupCenter(event, url, 560, 725);
  }

  if (socialShare) {
    trackSocial(socialShare.platform, socialShare.action);
    trainParselyProfile();
  }
}

function renderSocialList(empty, properties) {
  return (
    <ul className={`social__list ${empty ? 'social__list--post-empty' : ''}`}>
      {properties.map(sharer => {
        const { property, url, icon = '', popup, socialShare } = sharer;

        return (
          <li
            key={property}
            className={`social__item ${empty ? 'social__item--empty' : ''}`}
          >
            <a
              className={`social__link social__link--${property}`}
              href={url}
              onClick={e => handleClick(e, url, popup, socialShare)}
              rel="noopener noreferrer"
            >
              <i className={`icon-${icon || property}`} />
            </a>
          </li>
        );
      })}
    </ul>
  );
}

export default function Social(props) {
  if (!props) {
    return null;
  }

  const encodedPostUrl = props.uri;
  const encodedTitle = props.text || props.socialText;
  const properties = socialModel(encodedPostUrl, encodedTitle);
  const classes = ['social', `social--${props.modifier}`];

  return (
    <div className={classes.join(' ')} id={props.encapsulateId}>
      <Sticky
        top={props.topValue}
        bottomBoundary={props.bottomBoundary}
        enabled={props.enableSticky}
      >
        {renderSocialList(props.empty, properties)}
      </Sticky>
    </div>
  );
}

Social.defaultProps = {
  uri: 'https://www.fastcompany.com',
  text:
    'Fast Company is the world&#x27;s leading progressive business media brand, with a unique editorial focus on innovation in technology, leadership, and design.',
  modifier: 'default',
  topValue: 56,
  bottomBoundary: 0,
  encapsulateId: '',
  empty: false,
  enableSticky: false
};

Social.propTypes = {
  empty: PropTypes.bool,
  enableSticky: PropTypes.bool,
  modifier: PropTypes.string,
  uri: PropTypes.string,
  text: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  socialText: PropTypes.shape({
    twitter: PropTypes.string,
    linkedin: PropTypes.string,
    email: PropTypes.string
  }),
  bottomBoundary: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  encapsulateId: PropTypes.string,
  topValue: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/views/components/social/social.js